import { Trash } from "lucide-react";
import React, { useState } from "react";

export const CurrentMedications = ({
  setPatientMedicationInfo,
  patientMedicationInfo,
}) => {
  const [currentMedicationInfo, setcurrentMedicationInfo] = useState({
    takeingBloodThiner: "",
    nameBloodThiner: "",
  });
  const [addMedication, setAddMedication] = useState(1);
  const [addedMedication, setAddedMedication] = useState([]);
  const [medicationInfo, setMedicationInfo] = useState({
    medication: "",
    dosage: "",
    frequency: "",
    frequencyOther: "", // For "Other" frequency option
  });

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setMedicationInfo({ ...medicationInfo, [name]: value });
  };
  const handleDelete = (id) => {
    // Confirm deletion
    if (!window.confirm("Are you sure you want to delete this medication?")) {
      return;
    }
    
    // Delete from addedMedication state
    setAddedMedication((preData) => {
      const safePreData = Array.isArray(preData) ? preData : [];
      return safePreData.filter((item, index) => index !== id);
    });
    
    // Delete from patientMedicationInfo
    setPatientMedicationInfo((preData) => {
      const safeArray = Array.isArray(preData.currentMedicationInfo)
        ? preData.currentMedicationInfo
        : [];

      return {
        ...preData,
        currentMedicationInfo: safeArray.filter((_, index) => index !== id),
      };
    });
  };
  return (
    <>
      <div className="flex flex-col justify-start items-start gap-4 mb-5 bg-white p-5 shadow-sm rounded">
        <div className="my-2 flex flex-col gap-8 p-6 py-8 w-full  border-b border-[#d4d4d4]">
          <p className="font-mainFont font-[600] 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[2.3vw] text-[3.5vw] text-white">
            Are you currently taking any blood thinners or anti- coagulants?
          </p>
          <div className="flex justify-start items-center gap-4">
            <button
              onClick={() => {
                setcurrentMedicationInfo({
                  ...currentMedicationInfo,
                  takeingBloodThiner: "Yes",
                });
                setPatientMedicationInfo({
                  ...patientMedicationInfo,
                  takingBloodThinner: "Yes",
                });
              }}
              className={`text-[#333333] ${
                patientMedicationInfo.takingBloodThinner === "Yes"
                  ? "text-white BTNGradientBg"
                  : "text-black bg-white"
              }  px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper`}
            >
              Yes
            </button>
            <button
              onClick={() => {
                setcurrentMedicationInfo({
                  ...currentMedicationInfo,
                  takeingBloodThiner: "No",
                });
                setPatientMedicationInfo({
                  ...patientMedicationInfo,
                  takingBloodThinner: "No",
                });
              }}
              className={`text-[#333333]   px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper ${
                patientMedicationInfo.takingBloodThinner === "No"
                  ? "text-white BTNGradientBg"
                  : "text-black bg-white"
              }`}
            >
              No
            </button>
          </div>
        </div>

        {patientMedicationInfo.takingBloodThinner === "Yes" && (
          <div className="my-2 flex flex-col w-full gap-8 p-6 py-8 border-b border-[#d4d4d4]">
            <p className="font-mainFont font-[600] 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[2.3vw] text-[3.5vw] text-white">
              If YES, which ones?
            </p>
            <div className="flex flex-wrap justify-start items-center gap-4">
              <button
                onClick={() => {
                  setcurrentMedicationInfo({
                    ...currentMedicationInfo,
                    nameBloodThiner: "Aspirin",
                  });
                  setPatientMedicationInfo({
                    ...patientMedicationInfo,
                    nameBloodThinner: "Aspirin",
                  });
                }}
                className={`text-[#333333]   px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper ${
                  patientMedicationInfo.nameBloodThinner === "Aspirin"
                    ? "text-white BTNGradientBg"
                    : "text-black bg-white"
                }`}
              >
                Aspirin
              </button>
              <button
                onClick={() => {
                  setcurrentMedicationInfo({
                    ...currentMedicationInfo,
                    nameBloodThiner: "Plavix",
                  });
                  setPatientMedicationInfo({
                    ...patientMedicationInfo,
                    nameBloodThinner: "Plavix",
                  });
                }}
                className={`text-[#333333]   px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper ${
                  patientMedicationInfo.nameBloodThinner === "Plavix"
                    ? "text-white BTNGradientBg"
                    : "text-black bg-white"
                }`}
              >
                Plavix
              </button>
              <button
                onClick={() => {
                  setcurrentMedicationInfo({
                    ...currentMedicationInfo,
                    nameBloodThiner: "Coumadin",
                  });
                  setPatientMedicationInfo({
                    ...patientMedicationInfo,
                    nameBloodThinner: "Coumadin",
                  });
                }}
                className={`text-[#333333]   px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper ${
                  patientMedicationInfo.nameBloodThinner === "Coumadin"
                    ? "text-white BTNGradientBg"
                    : "text-black bg-white"
                }`}
              >
                Coumadin
              </button>
              <button
                onClick={() => {
                  setcurrentMedicationInfo({
                    ...currentMedicationInfo,
                    nameBloodThiner: "Xarelto",
                  });
                  setPatientMedicationInfo({
                    ...patientMedicationInfo,
                    nameBloodThinner: "Xarelto",
                  });
                }}
                className={`text-[#333333]   px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper ${
                  patientMedicationInfo.nameBloodThinner === "Xarelto"
                    ? "text-white BTNGradientBg"
                    : "text-black bg-white"
                }`}
              >
                Xarelto
              </button>

              <div className="flex justify-start items-center gap-4">
                <input
                  className=" w-full px-6 py-3 rounded-full border outline-none border-[#d4d4d4] font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333]/50 text-mainColor bg-[#f0f0f0]"
                  placeholder="Enter Manually"
                  value={patientMedicationInfo?.nameBloodThinner}
                  name="nameBloodThinner"
                  onChange={(event) => {
                    setPatientMedicationInfo({
                      ...patientMedicationInfo,
                      nameBloodThinner: event.target.value,
                    });
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="w-full mb-6 bg-white p-5 shadow-sm rounded">
        <div class="relative overflow-x-auto">
          <table class="w-full bg-white text-sm text-left rtl:text-right   font-mainFont">
            <thead class="text-xs  uppercase   text-black border-t  border-[#d4d4d4]">
              <tr>
                <th
                  scope="col"
                  class="px-6 py-3 font-[600] border-l border-r border-[#d4d4d4]"
                >
                  Medication
                </th>
                <th scope="col" class="px-6 py-3 font-[600]">
                  Dosage
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 border-l border-r border-[#d4d4d4] font-[600]"
                >
                  Frequency
                </th>

                {/* <th scope="col" class="px-6 py-3 font-[600]">
                  Period Approx. Taken
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 border-l border-r border-[#BDC3C7] font-[600]"
                >
                  CURRENTLY TAKING
                </th> */}
              </tr>
            </thead>

            <tbody>
              {Array(addMedication)
                .join()
                .split(",")
                .map((cur, id) => (
                  <tr key={id} class="bg-white text-black border-b   ">
                    <th
                      scope="row"
                      class="font-medium text-black whitespace-nowrap border border-[#d4d4d4] bg-[#f0f0f0]"
                    >
                      <input
                        className="w-full px-3 py-4 border border-none outline-none bg-transparent"
                        placeholder="Enter medication name"
                        name="medication"
                        value={medicationInfo.medication}
                        onChange={handleOnChange}
                      />
                    </th>
                    <td class=" border border-[#d4d4d4] bg-[#f0f0f0]">
                      <input
                        className="w-full px-3 py-4 border bg-transparent border-none outline-none"
                        placeholder="Enter Dose Amount"
                        type="number"
                        onChange={handleOnChange}
                        value={medicationInfo.dosage}
                        name="dosage"
                      />
                    </td>
                    <td class=" border border-[#d4d4d4] text-[#34495E] font-[400] bg-[#f0f0f0] font-[Poppins] p-2">
                      <div className="flex flex-col gap-2">
                        <select
                          onChange={handleOnChange}
                          value={medicationInfo.frequency}
                          name="frequency"
                          className="w-full bg-transparent h-full p-3 border-none outline-none mainFont"
                        >
                          <option value="">Select</option>
                          <option value="Daily">Daily</option>
                          <option value="Twice a week">Twice a week</option>
                          <option value="More than twice a week">More than twice a week</option>
                          <option value="Weekly">Weekly</option>
                          <option value="Other">Other</option>
                        </select>
                        {medicationInfo.frequency === "Other" && (
                          <input
                            type="text"
                            name="frequencyOther"
                            value={medicationInfo.frequencyOther}
                            onChange={handleOnChange}
                            placeholder="Please specify frequency..."
                            className="w-full px-3 py-2 border border-[#d4d4d4] rounded outline-none bg-white text-black"
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          <button
            type="button"
            onClick={() => {
              // Validate that at least medication name is provided
              if (!medicationInfo.medication || medicationInfo.medication.trim() === "") {
                alert("Please enter a medication name before adding.");
                return;
              }
              
              // Add medication to the list
              // If frequency is "Other", use the custom text, otherwise use the selected frequency
              const frequencyValue = medicationInfo.frequency === "Other" 
                ? (medicationInfo.frequencyOther.trim() || "Other")
                : medicationInfo.frequency;
              
              const newMedication = {
                medication: medicationInfo.medication.trim(),
                dosage: medicationInfo.dosage.trim(),
                frequency: frequencyValue,
              };
              
              setAddedMedication([...addedMedication, newMedication]);
              
              // Update patient medication info
              const currentArray = Array.isArray(patientMedicationInfo.currentMedicationInfo)
                ? patientMedicationInfo.currentMedicationInfo
                : [];
              
              setPatientMedicationInfo({
                ...patientMedicationInfo,
                currentMedicationInfo: [...currentArray, newMedication],
              });
              
              // Clear the form
              setMedicationInfo({
                medication: "",
                dosage: "",
                frequency: "",
                frequencyOther: "",
              });
            }}
            className="bg-secondaryColo BTNGradientBg  text-white font-mainFont font-[500] w-full py-3 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[2.3vw] text-[3.5vw] hover:opacity-90 transition-all duration-200"
          >
            Add Medication
          </button>
        </div>
      </div>

      <div className=" flex justify-start w-full  gap-5 flex-wrap my-5">
        {patientMedicationInfo?.currentMedicationInfo?.map(
          (curMedication, id) => (
            <div
              key={id}
              className="border border-[#d4d4d4] bg-white shadow-md p-5 rounded-xl flex flex-col gap-4 2xl:min-w-[20dvw] xl:min-w-[20dvw] lg:min-w-[20dvw] md:min-w-[20dvw] min-w-[80dvw]"
            >
              <div className="flex justify-between items-center">
                <h3 className="2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw] text-[3.5dvw] font-[700] text-[#333333]">
                  Mediacation {id + 1}
                </h3>
                <button
                  onClick={() => handleDelete(id)}
                  className="ml-auto p-2 flex justify-center items-center hover:text-white hover:bg-red-400 transition-all duration-200 ease-linear rounded-full shadow-lg"
                >
                  <Trash size={15} />
                </button>
              </div>
              <h3 className="2xl:text-[1dvw] xl:text-[1dvw] lg:text-[1dvw] md:text-[1dvw] text-[3.5dvw] font-[500] font-mainFont text-[#333333]/70">
                <strong>Medication</strong> :{" "}
                <span className="font-[400] text-black 2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw] text-[3.5dvw]">
                  {curMedication?.medication}
                </span>
              </h3>
              <h3 className="2xl:text-[1dvw] xl:text-[1dvw] lg:text-[1dvw] md:text-[1dvw] text-[3.5dvw] font-[500] font-mainFont text-[#333333]/70">
                <strong>Dosage</strong> :{" "}
                <span className="font-[400] text-black 2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw] text-[3.5dvw]">
                  {curMedication?.dosage}
                </span>
              </h3>
              <h3 className="2xl:text-[1dvw] xl:text-[1dvw] lg:text-[1dvw] md:text-[1dvw] text-[3.5dvw] font-[500] font-mainFont text-[#333333]/70">
                <strong>Frequency</strong> :{" "}
                <span className="font-[400] text-black 2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw] text-[3.5dvw]">
                  {curMedication?.frequency}
                </span>
              </h3>
            </div>
          )
        )}
      </div>
    </>
  );
};
